

































































import {Component, Inject, Vue} from 'vue-property-decorator';
import {SpectrumHarmWidget} from '@/views/dashboard/interfaces';
import WidgetBindDataSource from '@/components/widgets/base/WidgetBindDataSource.vue';
import Loading from '@c/controls/Loading.vue';
import {PModuleType} from '@/enums/configs';
import {PModuleWithMeasurements} from '@/views/system/modules/interfaces';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {SpectrumEventType} from '@/enums/diagrams';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {MeasurementType} from '@/views/system/measurements/enums';
import {DtcpAccelerometerFrequencyAndBandwidth} from '@/views/system/modules/interfaces';
import {getMeasurementById} from '@/utils/moduleUtils';
import {addScpectrSubscription} from '@/utils/socketUtils';
import {uuidv4} from '@/utils/uuidUtils';

@Component({
  components: {
    WidgetBindDataSource,
    Loading,
  },
})
export default class SpectrumHarmWidgetComponent extends Vue {
  //Данные виджета
  @Inject()
  widget!: SpectrumHarmWidget;

  @Inject()
  measurements!: MeasurementData[];

  id = uuidv4();

  // Точность представления нецелых чисел
  protected viewRoundingAccuracy = 1;

  // Значение гармоники спектра
  value: number | null = null;

  // Единицы измерения
  unit = '';

  spectrumType = SpectrumEventType.Envelop;

  // Верхняя граница гармоники спектра
  boundary = 30;

  // Показатели загрузки и наличия ошибок
  loading = true;
  error = false;

  // Цвет заголовка
  colorCaption = '#e5e5e5';

  // предустановленный фильтр с типом ПМ для выбора источника данных виджета
  // TODO после тестирования оставить только подходящие типы ПМ для предустановленного фильтра
  presetFilter = [PModuleType.DtcpAccelerometerModule, PModuleType.DtcpEnergyModule];

  presetMeasurementFilter = [MeasurementType.Spectrum];

  spectrumTypeFilter = [SpectrumEventType.Envelop];

  pmodule: PModuleWithMeasurements | null = null;

  nodeId: string | null = null;

  moduleGUID = '';

  measurement!: MeasurementData;

  freqband!: DtcpAccelerometerFrequencyAndBandwidth;

  // Действия при выборе оси
  onAxisSelect(data: any) {
    if (!data.pmodule || !data.nodeId) return;

    this.pmodule = data.pmodule;
    this.moduleGUID = data.pmodule.guid;
    this.widget.pmodule = data.pmodule;
    this.widget.nodeId = data.nodeId;
    this.widget.measurementId = data.measurementId;
    const measurement = getMeasurementById(this.measurements, data.measurementId);
    if (measurement) {
      this.measurement = measurement;
    }
    if (data.freqband) {
      this.freqband = data.freqband;
    }
    this.attachPM();
  }

  created() {
    if (!this.widget.pmodule) return;
    this.nodeId = this.widget.nodeId;
    this.pmodule = this.widget.pmodule;
    if (this.widget.pmodule.guid) this.moduleGUID = this.widget.pmodule.guid;
    const measurement = getMeasurementById(this.measurements, this.widget.measurementId);
    if (measurement) {
      this.measurement = measurement;
    }
    this.attachPM();
  }

  // Привязка датчика
  attachPM() {
    if (!this.pmodule || !this.pmodule?.guid || !this.measurement) return;

    this.unit = this.measurement.unit;
    this.$dataSocketManager.removeSubscription(this.id);
    this.loading = true;

    const params = {
      moduleType: this.pmodule.type,
      moduleGUID: this.pmodule.guid,
      eventType: this.measurement.eventType,
      spectrumType: this.spectrumType,
    };
    const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.spectrumType}/${params.eventType}`;
    const subscriptionFunction = (socket: WebSocket) =>
      addScpectrSubscription.call(this, socket, params);

    this.$dataSocketManager.addSubscription(
      this.id,
      subscrName,
      subscriptionFunction,
      this.subscribeConectionWS.bind(this),
    );
  }

  get formattedValue() {
    if (this.value == null) return 'н/д';
    let val = this.value;
    if (this.value > 10000) val = this.value / 1000;
    return val.toFixed(this.viewRoundingAccuracy);
  }

  get formattedUnit() {
    const unit = this.unit != '-' ? this.unit : '';
    if (this.value && this.value > 10000) return `тыс. ${unit}`;
    return `${unit}`;
  }

  // Получить хранилище
  get apiStore() {
    return pmoduleStoresByTypeMap.get(this.widget.pmodule.type) as any;
  }

  async subscribeConectionWS(e: {data: string}) {
    try {
      if (!this.measurement || !this.pmodule) return;
      this.error = false;
      const strParse = JSON.parse(e.data);
      if (!strParse) return;

      const {
        timestamp,
        module_identifier,
        event_type,
        spectrum_type,
      }: {
        timestamp: number;
        module_identifier: string;
        event_type: string;
        spectrum_type: string;
      } = strParse;

      if (
        module_identifier !== this.pmodule.guid ||
        event_type !== this.measurement.eventType ||
        +spectrum_type !== this.spectrumType
      ) {
        return;
      }

      const {spectrum} = await this.apiStore.getSpectrum({
        id: this.pmodule?.id,
        date: timestamp,
        spectrumType: this.spectrumType,
        fieldAlias: this.measurement.alias,
        central_frequency: this.freqband.central_frequency,
        bandwidth: this.freqband.bandwidth,
      });
      this.value = spectrum[0].y;
    } catch {
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  beforeDestroy() {
    this.closeWS();
  }

  // Закрыть соединения веб сокетов
  closeWS() {
    if (this.$dataSocketManager) this.$dataSocketManager.removeSubscription(this.id);
  }
}
